export const EMPTY_VALUE = 'Non renseigné';
